// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".joborder-prev[data-v-d474b606]{background:grey}.joborder-next[data-v-d474b606],.joborder-prev[data-v-d474b606]{display:inline-block;height:10px;width:20px}.joborder-next[data-v-d474b606]{background:#4299e1}.joborder-current[data-v-d474b606]{display:inline-block;height:10px;width:20px;border:1.5px solid #fa8b59}", ""]);
// Exports
module.exports = exports;
